// Número digitado em pt-BR. Sem dependências: testado com `npm test`.

/** "30,50" ou "30.5" → 30.5; vazio → null; texto que não é número → NaN (a tela avisa). */
export function lerNumero(v: string): number | null {
  const t = v.trim().replace(/\s/g, '').replace(/^R\$/i, '')
  if (!t) return null
  const normal = t.includes(',') ? t.replace(/\./g, '').replace(',', '.') : t
  return Number(normal)
}
